import { render, staticRenderFns } from "./PaywallForm.vue?vue&type=template&id=b878a3fc&scoped=true"
import script from "./PaywallForm.vue?vue&type=script&lang=js"
export * from "./PaywallForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b878a3fc",
  null
  
)

export default component.exports